// extracted by mini-css-extract-plugin
module.exports = {"component":"About_component__ygoW_","neonText":"About_neonText__3SHxz","flipCard":"About_flipCard__eM03M","cardFront":"About_cardFront__2MetS","cardBack":"About_cardBack__19Aeu"};